import {
  AfterViewChecked,
  AfterViewInit,
  Directive,
  ElementRef,
  NgZone,
  OnChanges,
  SimpleChanges,
  inject,
  input,
  output,
} from '@angular/core';
import { DatePickerComponent, DateTimePickerComponent, TimePickerComponent } from '@progress/kendo-angular-dateinputs';

@Directive({
  selector: '[cueFoldable]',
  standalone: true,
})
export class FoldableDirective implements AfterViewChecked {
  private elementRef = inject(ElementRef);
  itemIdx = input<number>();
  heightValueChanged = output<number>();

  ngAfterViewChecked(): void {
    const height = this.elementRef.nativeElement.offsetHeight;
    this.heightValueChanged.emit(height);
    // const parentElement = document.getElementById('hiddablePart');
    //
    // if (height <= 50) {
    //   parentElement.classList.add('hidden');
    // } else {
    //   parentElement.classList.remove('hidden');
    // }
  }
}
